import styled from 'styled-components';

export const Label = styled.label`
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  margin: 1.5rem 0;
  color: #fff;

  > span:first-child {
    color: #e04a66 !important;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.3;
  }
  > textarea {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    color: #dee2e6;
    font-size: 14px;
    background: #323a4e;
    transition: 180ms ease-in-out;
    :focus {
      box-shadow: none;
      border-color: rgba(255, 255, 255, 0.1);
    }
  }
  > button {
    position: absolute;
    border: 0;
    background: none;
    padding: 0;
    right: 1rem;
    top: 2.8rem;
    z-index: 2;
    :hover {
      transform: scale(1.1);
    }
  }
`;
